<app-language-picker
  [selectedLanguageCode]="supportService.getCurrentLanguage().code"
  (onSelect)="refreshPageWithSelectedLanguage($event)"
></app-language-picker>
